/** Device-question categories (labels only, no questions): the settings sheet shows these as chips. */
export const PN_CATEGORIES = [
  { id: 'battery', label: 'Battery' },
  { id: 'storage', label: 'Storage' },
  { id: 'camera-roll', label: 'Camera roll' },
  { id: 'settings', label: 'Settings' },
  { id: 'apps', label: 'Apps & inbox' },
  { id: 'hardware', label: 'The phone itself' },
] as const;

export type PnCategory = (typeof PN_CATEGORIES)[number]['id'];
export const PN_CATEGORY_IDS = PN_CATEGORIES.map((c) => c.id) as [PnCategory, ...PnCategory[]];

/** Camera Roll Hunt prompt categories (labels only). */
export const PHOTO_CATEGORIES = [
  { id: 'animals', label: 'Animals' },
  { id: 'food', label: 'Food & drink' },
  { id: 'places', label: 'Places & nature' },
  { id: 'selfies', label: 'Selfies (of you)' },
  { id: 'funny', label: 'Funny & weird' },
  { id: 'throwbacks', label: 'Throwbacks' },
  { id: 'screenshots', label: 'Screenshots' },
  { id: 'colors', label: 'Colours & shapes' },
  { id: 'events', label: 'Holidays & events' },
  { id: 'home', label: 'Things at home' },
  { id: 'out', label: 'Out & about' },
  { id: 'vehicles', label: 'Vehicles' },
] as const;

export type PhotoCategory = (typeof PHOTO_CATEGORIES)[number]['id'];
export const PHOTO_CATEGORY_IDS = PHOTO_CATEGORIES.map((c) => c.id) as [PhotoCategory, ...PhotoCategory[]];

/** The three rounds, in play order. */
export const PN_ROUNDS = [
  { id: 'device', name: 'Device Check', blurb: 'Answer for your own phone, then guess the room.' },
  { id: 'texts', name: 'Sent Texts', blurb: 'A text you really sent (or a harmless fake). Who sent which?' },
  { id: 'photos', name: 'Camera Roll Hunt', blurb: 'Find it in your photos. The fastest real match wins.' },
] as const;
export type PnRoundId = (typeof PN_ROUNDS)[number]['id'];
